import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IconButton, } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { showMessage } from 'app/store/fuse/messageSlice';

const Noah = ({ open, onClose, props }) => {
    const [data2, setData2] = useState([]);
    const dispatch = useDispatch();
    const { t } = useTranslation('translate-language');
    const [data, setData] = useState({
        'FirstName': '',
        'LastName': '',
        'ActivePatient': true,
        'Gender': 'Male',
        'BirthDate': '1999-05-11T00:00:00',
        'CreateDate': moment().format("YYYY-MM-DD[T]HH:mm:ss"),
        'City': 'Uzbekistan',
        'Address1': 'Yunusbod',
        'BackEndSystemPatientId': '',

    });
  
    
    useEffect(() => {
        if (props) {
            axios.get(`v1/client/get-by-id/${props}`).then(response => {
                setData2(response.data)

                setData({
                    'FirstName': response.data.name,
                    'LastName': response.data.last_name,
                    'MobilePhone': response.data.phone_number,
                    'ActivePatient': true,
                    'Gender': (response.data.gender == "MALE") ? "Male" : "Female",
                    'BirthDate': `${response.data.birthday}T00:00:00`,
                    'CreateDate': moment().format("YYYY-MM-DD[T]HH:mm:ss"),
                    'City': response.data.city,
                    'Address1': response.data.city,
                    'BackEndSystemPatientId': response.data.id,
                })
            })
        }
    }, [props]);

    const handleNoah = async () => {

        if (data2.is_noah_client == "YES") {
            const response_get = await fetch(`http://localhost:3000/get-id?id=${props}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        } else {
            let text = `<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">
        <s:Body>
            <ImportPatients xmlns="http://himsa.org">
                <NoahLocation />
                <BusinessSystemUserId>WSI</BusinessSystemUserId>
                <data>&lt;?xml version="1.0" encoding="utf-8"?&gt; &lt;NOAHDataExchange xmlns="http://www.himsa.com/XMLWrapper/XMLWrapper"&gt; &lt;NoahDataExchangeProtocol&gt; &lt;NoahSiteID&gt;DESKTOP-R8V2UQ5&lt;/NoahSiteID&gt; &lt;NoahUserID&gt;ABC&lt;/NoahUserID&gt; &lt;BusinessSystemUserID&gt;WSI&lt;/BusinessSystemUserID&gt; &lt;TransmissionID&gt;0&lt;/TransmissionID&gt; &lt;pt:Patients xmlns:pt="http://www.himsa.com/PatientExport/PatientExport"&gt; &lt;pt:Patient&gt; &lt;pt:FirstName&gt;${data.FirstName}&lt;/pt:FirstName&gt; &lt;pt:LastName&gt;${data.LastName}&lt;/pt:LastName&gt; &lt;pt:ActivePatient&gt;${data.ActivePatient}&lt;/pt:ActivePatient&gt; &lt;pt:Gender&gt;${data.Gender}&lt;/pt:Gender&gt; &lt;pt:BirthDate&gt;${data.BirthDate}&lt;/pt:BirthDate&gt; &lt;pt:UserId&gt;ABC&lt;/pt:UserId&gt; &lt;pt:CreateDate&gt;${data.CreateDate}&lt;/pt:CreateDate&gt; &lt;pt:Address1&gt;${data.Address1}&lt;/pt:Address1&gt; &lt;pt:City&gt;${data.City}&lt;/pt:City&gt; &lt;pt:WorkTelephone&gt;${data.MobilePhone}&lt;/pt:WorkTelephone&gt; &lt;pt:BackEndSystemPatientId&gt;${data.BackEndSystemPatientId}&lt;/pt:BackEndSystemPatientId&gt; &lt;pt:Actions /&gt; &lt;/pt:Patient&gt; &lt;/pt:Patients&gt; &lt;/NoahDataExchangeProtocol&gt; &lt;/NOAHDataExchange&gt;</data>
            </ImportPatients>
        </s:Body>
</s:Envelope>`

            const response = await fetch('http://localhost:3000', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    data: text, // 'text' o'zgaruvchisi to'g'ri qiymatga ega ekanligini tekshiring
                }),
            });

            if (response.status == 200) {
                axios.put(`/v1/client/update/${props}`, { ...data2, "is_noah_client": "YES" }).then(response => {
                    dispatch(showMessage({
                        message: 'Noahga qo`shildi',
                        variant: 'success',
                    }));
                })

                const response2 = await fetch('http://localhost:3000/get-on', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
            } else {
                dispatch(showMessage({
                    message: 'Noahga qo`shilmadi',
                    variant: 'error',
                }));
            }

        };
        setData2([]);
        setData({
            'FirstName': '',
            'LastName': '',
            'ActivePatient': true,
            'Gender': 'Male',
            'BirthDate': '1999-05-11T00:00:00',
            'CreateDate': moment().format("YYYY-MM-DD[T]HH:mm:ss"),
            'City': 'Toshkent',
            'Address1': 'Yunusbod',
            'BackEndSystemPatientId': '',
    
        })
    }

    return (
        <>
            <IconButton class="w-48 h-48 hover:bg-grey-200 p-8 rounded-full" onClick={(e) => {
                handleNoah(e);
            }}>
                <img className="h-32 w-32 object-contain" src="assets/images/noah-4.png" title="Noah 4" />
            </IconButton>
        </>
    );
};

export default Noah;
